export default {
    index: {
        title: "首页",
        keywords: "剑网3,魔盒,JX3BOX,工具,攻略,资讯,社区",
        description: "剑网3魔盒（JX3BOX）首页：公告资讯、社区内容、江湖快报等。",
    },
    notice: {
        title: "公告中心",
        keywords: "公告,资讯,更新,活动,兑换通知,JX3BOX",
        description: "公告中心：查看剑网3魔盒的公告动态、运营活动、功能更新与兑换通知。",
        single: {
            title: "公告详情",
            keywords: "公告详情,公告,资讯,JX3BOX",
            description: "公告详情页：阅读公告内容、查看更新信息与互动数据。",
        },
    },
};
